import DossierDetail from "@/pages/DossierDetail";

/** Fiche annonce dans une modale (pile interne, sans changer d’onglet). */
export default function ModalDossierEmbed({ dossierId, onBack, backLabel = "Retour", hideNavBack = true }) {
  if (!dossierId) return null;
  return (
    <div className="min-h-0" data-testid="modal-dossier-embed">
      <DossierDetail
        embedDossierId={dossierId}
        onEmbedClose={onBack}
        embedBackLabel={backLabel}
        embedHideNavBack={hideNavBack}
        embedCompact
      />
    </div>
  );
}
